export const scoreColor = (s) => (s >= 75 ? "#2E7D32" : s >= 50 ? "#006CFF" : s >= 30 ? "#FF9900" : "#5C5E66");
export const scoreBg = (s) => (s >= 75 ? "#2E7D3214" : s >= 50 ? "#006CFF14" : s >= 30 ? "#FF990014" : "#5C5E6614");

export const ScoreBadge = ({ score, testid }) => {
  if (score === undefined || score === null) return <span className="text-[#5C5E66] text-xs">—</span>;
  return (
    <span
      data-testid={testid}
      className="inline-flex items-center px-2 py-0.5 text-[10px] font-mono tabular-nums"
      style={{ background: scoreBg(score), color: scoreColor(score), border: `1px solid ${scoreColor(score)}33` }}
    >
      {score}/100
    </span>
  );
};
